
export const REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST = "REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST";
export const REPORT_WHOLESALER_MONTH_REPORT_BYID_SUCCESS = "REPORT_WHOLESALER_MONTH_REPORT_BYID_SUCCESS";
export const REPORT_WHOLESALER_MONTH_REPORT_BYID_FAILURE = "REPORT_WHOLESALER_MONTH_REPORT_BYID_FAILURE";

export const REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST = "REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST";
export const REPORT_WHOLESALER_WEEK_REPORT_BYID_SUCCESS = "REPORT_WHOLESALER_WEEK_REPORT_BYID_SUCCESS";
export const REPORT_WHOLESALER_WEEK_REPORT_BYID_FAILURE = "REPORT_WHOLESALER_WEEK_REPORT_BYID_FAILURE";

export const REPORT_WHOLESALER_REPORT_BYID_REQUEST = "REPORT_WHOLESALER_REPORT_BYID_REQUEST";
export const REPORT_WHOLESALER_REPORT_BYID_SUCCESS = "REPORT_WHOLESALER_REPORT_BYID_SUCCESS";
export const REPORT_WHOLESALER_REPORT_BYID_FAILURE = "REPORT_WHOLESALER_REPORT_BYID_FAILURE";

//Date Search
export const WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST = "WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST";
export const WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_SUCCESS = "WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_SUCCESS";
export const WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_FAILURE = "WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_FAILURE";
export const WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_RESET = "WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_RESET";

export const WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST = "WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST";
export const WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_SUCCESS = "WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_SUCCESS";
export const WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_FAILURE = "WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_FAILURE";
export const WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_RESET = "WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REST";

export const WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST = "WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST";
export const WHOLESALER_REPORT_BYID_DATE_SEARCH_SUCCESS = "WHOLESALER_REPORT_BYID_DATE_SEARCH_SUCCESS";
export const WHOLESALER_REPORT_BYID_DATE_SEARCH_FAILURE = "WHOLESALER_REPORT_BYID_DATE_SEARCH_FAILURE";
export const WHOLESALER_REPORT_BYID_DATE_SEARCH_RESET = "WHOLESALER_REPORT_BYID_DATE_SEARCH_RESET";

//search
export const REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST = "REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST";
export const REPORT_WHOLESALER_REPORT_BYID_SEARCH_SUCCESS = "REPORT_WHOLESALER_REPORT_BYID_SEARCH_SUCCESS";
export const REPORT_WHOLESALER_REPORT_BYID_SEARCH_FAILURE = "REPORT_WHOLESALER_REPORT_BYID_SEARCH_FAILURE";
